import { useMemo } from "react";
import apiInstance from "../../helpers/apiInstance";
import { useApp } from "../../contexts/AppContext";

function useOrganization() {
  const basePath = useMemo(() => {
    return `/organization`;
  }, []);

  const { organizationId } = useApp();

  return {
    createOrganization: (payload) => apiInstance.post(basePath, payload),
    updateOrganization: (payload) => apiInstance.put(basePath, payload),
    deleteOrganization: () => apiInstance.delete(basePath),
    getOrganizationMembers: () =>
      apiInstance.get(organizationId + "/member/get-members"),
  };
}

export default useOrganization;
